import axios        from 'axios';
import {router}     from '../../router/router.js'
import {SERVER_PATH} from '../../config.js'
import analytics    from '../../services/analytics'
import realtime     from '../../services/realtime'

const postAuthDestination = () => {
    var currentRoute = router && router.currentRoute
    var redirect = currentRoute && currentRoute.query ? currentRoute.query.redirect : ''
    if(typeof redirect == 'string' && redirect.charAt(0) == '/' && redirect.indexOf('//') !== 0){
        return redirect
    }
    return '/users/dashboard'
}

const state = {
    tooltips: [],
    buildExceptions: [
        'id',
        'author_id'
    ],
    miningProfit:   {},
    lastRoute:      'builder/' + 'home',
    token:          localStorage.getItem('usertoken')       || null,
    refreshToken:   localStorage.getItem('refreshToken')    || null,
    loggedInState:  localStorage.getItem('logged_in')       || 'false',
    error:          null,
    user:           localStorage.getItem('user')            || null,
    pendingConfirmationEmail: sessionStorage.getItem('gixcore_pending_confirmation_email') || '',
    buildAdded:     null,
    userBuilds:     null,
    buildsLoaded:   true,
    profitListLoaded:true,
    stillHover:     false
};

const getters = {
    getTooltips:        (state) => state.tooltips,
    getProfitListLoaded:(state) => state.profitListLoaded,
    getProfitability:   (state) => state.miningProfit,
    getUserBuilds:      (state) => state.userBuilds,
    getUser:            (state) => state.user,
    getToken:           (state) => state.token,
    lastRoute:          (state) => state.lastRoute,
    loggedIn:           (state) => state.loggedInState,
    getError:           (state) => state.error,
    getBuildAdded:      (state) => state.buildAdded,
    ifBuildsLoaded:     (state) => state.buildsLoaded,
    pendingConfirmationEmail: (state) => state.pendingConfirmationEmail,
};

const actions = {
    async showTooltip({commit, state}, tooltip){
        if(tooltip){
            commit('HOVER_TRUE')
            setTimeout(() => {
                if(state.stillHover == true){
                    commit('SHOW_TOOLTIP', tooltip)
                }
            }, 500) 
        }
    },
    hideTooltip({commit}, tooltip){
        if(tooltip){
            commit('HIDE_TOOLTIP', tooltip)
        }
    },
    async fetchMiningProfitability({commit}){
        console.log('fetching mining profit. list: ')
        commit('PROFIT_LIST_LOADED', false)
            await axios({
                url: `http://api2.nicehash.com/main/api/v2/public/stats/global/current`,
                method: "get",
                headers: {
                    'Content-Type': `application/json`
                }
            })
            .then((response) => {
                console.log('received mining prof response', response.data)
                commit('RECORD_MINING_PROFITABILITY', response.data.Build)
                commit('PROFIT_LIST_LOADED', true)
                console.log(response)
            })
            .catch((e) => {
                commit('PROFIT_LIST_LOADED', true)
                console.log(e)
            })
    },
    async fetchUserBuilds({commit}, user_id){
        console.log('fetching user builds with id: ', user_id)
        commit('BUILDS_LOADED', false)
        if(user_id !== null || user_id !== ''){
            await axios({
                url: `${SERVER_PATH}builds/builds?author_id=${user_id}`,
                method: "get",
                headers: {
                    'Content-Type': `application/json`,
                    'Authorization': `Bearer ${localStorage.usertoken}`,
                    'alg': "HS256",
                    'typ': "JWT"
                }
            })
            .then((response) => {
                console.log('received builds', response.data)
                commit('RECORD_USER_BUILDS', response.data.Build)
                commit('BUILDS_LOADED', true)
                console.log(response)
            })
            .catch((e) => {
                commit('BUILDS_LOADED', true)
                console.log(e)
            })
        }
    },
    async login({commit}, credentials) {
        console.log('LOGIN....', SERVER_PATH)
        return new Promise((resolve, reject) => {
             axios.post(`${SERVER_PATH}users/auth/login`, Object.assign({
                email: credentials.email,
                password: credentials.password,
                captchaToken: credentials.captchaToken
            }, analytics.identity()), { headers: analytics.headers() })
            .then((response) => {
                console.log(response)
                const token =           response.data.token
                const refreshToken =    response.data.refreshToken
                localStorage.setItem(   'usertoken', token)
                localStorage.setItem(   'refreshToken', refreshToken)
                console.log(localStorage.usertoken)
                // context.commit(         'retrieveToken', token)
                resolve(response)
                console.log('login success, redirecting...')
                router.push({path: postAuthDestination()})
            })
            .catch((err) => {
                commit('NEW_ERROR', err)
                console.log(err)
                reject(err)
            })
        })
    },
    async googleLogin({commit}, credential) {
        return new Promise((resolve, reject) => {
            axios.post(`${SERVER_PATH}users/auth/google`, Object.assign({ credential }, analytics.identity()), { headers: analytics.headers() })
            .then((response) => {
                const data = response.data || {}
                const token = data.token || data.accessToken || data.access_token
                const refreshToken = data.refreshToken || data.refresh_token || ''
                const user = data.User || data.user || null

                if (!token) {
                    throw new Error('Google sign-in did not return a session token.')
                }

                localStorage.setItem('usertoken', token)
                if (refreshToken) {
                    localStorage.setItem('refreshToken', refreshToken)
                } else {
                    localStorage.removeItem('refreshToken')
                }
                commit('retrieveToken', token)
                commit('SET_REFRESH_TOKEN', refreshToken)
                commit('LOGGED_IN')
                if (user) {
                    commit('SET_USER', user)
                }
                resolve(response)
                router.push({path: postAuthDestination()})
            })
            .catch((err) => {
                commit('NEW_ERROR', err)
                console.log(err)
                reject(err)
            })
        })
    },
    async register({commit}, credentials){
        try {
            const response = await axios.post(`${SERVER_PATH}users/auth/register`,
                {
                    email: credentials.email,
                    password: credentials.password,
                    username: credentials.username,
                    first_name: credentials.first_name,
                    last_name: credentials.last_name,
                    captchaToken: credentials.captchaToken
                })

            console.log('register success, response: ', response)
            const emailSent = !(response.data && (response.data.emailSent === false || response.data.emailSent === 'false'))
            commit('SET_PENDING_CONFIRMATION_EMAIL', credentials.email)
            sessionStorage.setItem('gixcore_pending_confirmation_email_sent', emailSent ? '1' : '0')
            router.push({name: 'RegisterSuccess', query: { sent: emailSent ? '1' : '0' }})
            return response
        }
        catch(err) {
            commit('NEW_ERROR', err)
            console.log(err)
            throw err
        }
    },
    async resendConfirmation({commit, state}, data){
        try {
            const email = data && data.email ? data.email : state.pendingConfirmationEmail
            const response = await axios.post(`${SERVER_PATH}users/auth/register/resend`, { email })
            if (email) {
                commit('SET_PENDING_CONFIRMATION_EMAIL', email)
            }
            return response
        }
        catch(err) {
            commit('NEW_ERROR', err)
            console.log(err)
            throw err
        }
    },
    // Password reset / setup flow. The same endpoints serve "forgot password"
    // (password users) and "create password" (Google-only users). The forgot
    // call always resolves generically so we never leak which emails exist.
    async forgotPassword({commit}, data){
        try {
            const email = data && data.email ? data.email : ''
            const captchaToken = data && data.captchaToken ? data.captchaToken : ''
            return await axios.post(`${SERVER_PATH}users/auth/password/forgot`, { email, captchaToken })
        }
        catch(err) {
            commit('NEW_ERROR', err)
            console.log(err)
            throw err
        }
    },
    async validateResetToken({commit}, token){
        try {
            return await axios.get(`${SERVER_PATH}users/auth/password/reset/${encodeURIComponent(token)}`)
        }
        catch(err) {
            commit('NEW_ERROR', err)
            console.log(err)
            throw err
        }
    },
    async resetPassword({commit}, data){
        try {
            return await axios.post(`${SERVER_PATH}users/auth/password/reset`, {
                token: data.token,
                password: data.password,
                password_confirmation: data.password_confirmation
            })
        }
        catch(err) {
            commit('NEW_ERROR', err)
            console.log(err)
            throw err
        }
    },
    async validate({commit}){
        return await axios({
            url: `${SERVER_PATH}users/auth/validate`,
            method: "post",
            headers: {
                'Content-Type': `application/json`,
                'Authorization': `Bearer ${localStorage.usertoken}`,
                'alg': "HS256",
                'typ': "JWT"
            }
        }) 
            .then((response) => {
                var user = response.data['User']
                commit('SET_USER', user)
                commit('LOGGED_IN')
               return response
            })
            .catch((err) => {
                commit('LOGGED_OUT')
            console.log(err)
        })
    },
    async update({commit}, data){
        console.log('update started, sending:')
        console.log(data)
        try {
            const response = await axios({
                url: `${SERVER_PATH}users/auth/update`,
                method: 'post',
                headers: {
                    'Content-Type': `application/json`,
                    'Authorization': `Bearer ${localStorage.usertoken}`,
                    'alg': "HS256",
                    'typ': "JWT"
                },
                data: JSON.stringify(data)
            })

            if (response.data && response.data.User) {
                commit('SET_USER', response.data.User)
            }

            console.log('update successful')
            return response;
        }
        catch(error) {
            commit('NEW_ERROR', error)
            console.log(error)
            throw error
        }
    },
    async logout({ commit, state }){
        const token = state.token || localStorage.getItem('usertoken')
        const refreshToken = state.refreshToken || localStorage.getItem('refreshToken')
        try {
            const response = await axios({
                url: `${SERVER_PATH}users/auth/logout`,
                method: "post",
                headers: {
                    'Content-Type': `application/json`,
                    'Authorization': `Bearer ${token}`,
                    'alg': "HS256",
                    'typ': "JWT"
                },
                data: { refreshToken }
            })
            console.log(response)
            return response
        }
        catch(err) {
            console.log(err)
            return null
        }
        finally {
            realtime.disconnect()
            localStorage.removeItem('usertoken')
            commit('LOGGED_OUT')
        }
    },
    async getLastRoute({ commit }, route){
        commit('newRoute', route)
    },
    async LoggedInCheck({ commit }, loggedIn){
        commit('checkIfLoggedIn', loggedIn)
    },
    setLoggedIn({commit}){
        commit('LOGGED_IN')
    },
    setLoggedOut({commit}, state){
        commit('LOGGED_OUT', state)
    },
    setError({commit}, error){
        commit('NEW_ERROR', error)
        console.log('error recorded', error)
    },
    setBuildAdded({commit}, message){
        commit('BUILD_ADDED', message)
    },
    checkBuildStatus(build){
        console.log('checkbuildstatus started, build: ', build)       
    }
};

const mutations = {
    PROFIT_LIST_LOADED(state, bool){
        state.profitListLoaded = bool
    },
    RECORD_MINING_PROFITABILITY(state, list){
        state.miningProfit = [...list]
    },
    BUILDS_LOADED(state, bool){
        state.buildsLoaded = bool
    },
    RECORD_USER_BUILDS(state, builds){
        // Loop Through List of Builds
        console.log('recording user builds ', builds)
        var essentials = [
            'processor',
            'motherboard',
            'ram',
            'psu',
            'storage',
            'case'
        ]
        var totalCost = 0;
        for (let i = 0; i < builds.length; i++) {
            for (const property in builds[i]) {
                if(property == 'case' && builds[i][property] !== null){
                   builds[i]['image'] = JSON.parse(builds[i][property].imgUrl)[0]
                }
                else if(property == 'processor' && builds[i][property] !== null){
                    builds[i]['image'] = JSON.parse(builds[i][property].imgUrl)[0]
                }
                else if(property == 'motherboard' && builds[i][property] !== null){
                    builds[i]['image'] = JSON.parse(builds[i][property].imgUrl)[0]
                }
                else {
                    if (builds[i][property] !== null && builds[i][property].imgUrl && JSON.parse(builds[i][property].imgUrl).length > 0){
                        builds[i]['image'] = JSON.parse(builds[i][property].imgUrl)[0]
                    }
                }
                if (typeof(builds[i][`${property}_id`]) == 'number' && property !== 'accessories'){
                    if(essentials.length==1){
                        essentials = []
                    }
                    else {
                        essentials.splice(1, essentials.indexOf(`${property}`))
                    }
                }
            }
            builds[i]['cost'] = totalCost
            if(essentials.length > 0){
                builds[i]['status'] = 'incomplete'
                console.log(builds[i]['status'])
                
            }
            else if (essentials.length == 0) {
                builds[i]['status'] = 'complete'
            }
        }
        state.userBuilds = builds;
        console.log('user builds recorded: ', builds)
    },
    SET_USER (state, user){
        state.user = user
        localStorage.setItem('user', JSON.stringify(user))
    },
    SET_PENDING_CONFIRMATION_EMAIL (state, email){
        state.pendingConfirmationEmail = email || ''
        if (email) {
            sessionStorage.setItem('gixcore_pending_confirmation_email', email)
        } else {
            sessionStorage.removeItem('gixcore_pending_confirmation_email')
        }
    },
    LOGGED_IN (state){
        localStorage.setItem('logged_in', true)
        state.loggedInState = 'true'
    },
    LOGGED_OUT (state){
        localStorage.removeItem('user')
        localStorage.removeItem('refreshToken')
        state.user = null
        state.token = null
        state.refreshToken = null
        window.localStorage.removeItem('logged_in')
        state.loggedInState = 'false'
    },
    SHOW_TOOLTIP       (state, tooltip){
        var tooltips = [...state.tooltips]
        if(!tooltips.includes(tooltip) && state.stillHover == true){
           tooltips.push(tooltip)
        }
        state.tooltips  = tooltips
        console.log('tooltip ', tooltip , ' is added')
    },
    HIDE_TOOLTIP       (state, tooltip){
        var tooltips = [...state.tooltips]
        if(tooltips.includes(tooltip)){
           tooltips.splice(tooltips.indexOf(tooltip), 1)
        }
        state.tooltips  = tooltips
        state.stillHover = false
    },
    HOVER_TRUE:         (state)             => state.stillHover = true,
    NEW_ERROR:          (state, err)        => state.error = err,
    BUILD_ADDED:        (state, message)    => state.buildAdded = message,
    newRoute:           (state, route)      => state.lastRoute = route,
    checkIfLoggedIn:    (state, loggedIn)   => state.loggedInState = loggedIn,
    retrieveToken       (state, token) {
        state.token = token
    },
    SET_REFRESH_TOKEN (state, token) {
        state.refreshToken = token || null
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}
